// Grados de la AMMDK en orden. La usan la app y el Worker (validación del servidor).
export const BELTS=[
  {id: 'blanca',label: 'Blanca'},
  {id: 'blanca_avanzada',label: 'Blanca Avanzada'},
  {id: 'amarilla',label: 'Amarilla'},
  {id: 'amarilla_avanzada',label: 'Amarilla Avanzada'},
  {id: 'verde',label: 'Verde'},
  {id: 'verde_avanzada',label: 'Verde Avanzada'},
  {id: 'azul',label: 'Azul'},
  {id: 'azul_avanzada',label: 'Azul Avanzada'},
  {id: 'marron',label: 'Marrón'},
  {id: 'marron_avanzada',label: 'Marrón Avanzada'},
  {id: 'roja',label: 'Roja'},
  {id: 'roja_avanzada',label: 'Roja Avanzada'},
  {id: 'negra_1',label: '1er Dan / Poom'},
  {id: 'negra_2',label: '2do Dan'},
  {id: 'negra_3',label: '3er Dan'},
  {id: 'negra_4',label: '4to Dan'},
  {id: 'negra_5',label: '5to Dan'},
  {id: 'negra_6',label: '6to Dan'},
  {id: 'negra_7',label: '7mo Dan'},
  {id: 'negra_8',label: '8vo Dan'},
  {id: 'negra_9',label: '9no Dan'},
];

export const BELT_IDS=BELTS.map(belt=> belt.id);

export const beltLabel=(id)=> BELTS.find(belt=> belt.id===id)?.label || id;
